const iconArray = [
  { id: 1, name: 'GitHub',     url: 'https://github.com/DevelopedByDrewford',                icon: 'github'     },
  { id: 2, name: 'LinkedIn',   url: 'https://www.linkedin.com/in/developedbydrewford/',      icon: 'linkedin'   },
  { id: 3, name: 'Instagram',  url: 'https://www.instagram.com/developedbydrewford/',        icon: 'instagram'  },
  { id: 4, name: 'TikTok',     url: 'https://www.tiktok.com/@developedbydrewford',           icon: 'tiktok'     },
  { id: 5, name: 'SmugMug',    url: 'https://drewford.smugmug.com',                          icon: 'smugmug'    },
  { id: 6, name: 'Letterboxd', url: 'https://letterboxd.com/DevByDrewford/',                 icon: 'letterboxd' },
];

export default iconArray;
